import { motion } from "framer-motion";
import CashAppLine from "./CashAppLine";

export default function ChurchBanner() {
  return (
    <section className="relative w-full bg-[#05030A] pt-28 pb-14 sm:pt-32 sm:pb-16 px-5 sm:px-8 overflow-hidden" data-testid="church-banner">
      <div className="absolute left-1/2 -translate-x-1/2 -top-24 w-[640px] h-[320px] rounded-full bg-[#6A0DAD]/20 blur-[130px]" />
      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-light text-white tracking-tight leading-[1.05] whitespace-nowrap text-[clamp(1.05rem,4.2vw,2.6rem)]"
          data-testid="church-banner-name"
        >
          Fountain of Living Water Apostolic Church
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 font-mono tracking-[0.45em] uppercase text-[#7DD3FC] text-lg sm:text-xl [text-shadow:0_0_24px_rgba(125,211,252,0.45)]"
          data-testid="church-banner-acronym"
        >
          F. O. L. W. A. C.
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="mt-6 max-w-3xl mx-auto text-[#C9C3D4] font-light leading-relaxed text-base md:text-lg"
          data-testid="church-banner-mission"
        >
          F.O.L.W.A.C. Exists to proclaim Jesus Christ, lead people toward biblical salvation, establish believers in apostolic doctrine, restore families, cultivate compassionate community, and prepare disciples to serve faithfully in a troubled and spiritually thirsty world.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 28, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 mx-auto max-w-xl"
          data-testid="church-banner-image-wrap"
        >
          <img
            src="https://customer-assets-4nw71qhi.emergentagent.net/job_apostolic-ai-church/artifacts/n9eppq3q_FOLWAC.png"
            alt="F.O.L.W.A.C. — Are You A New Creation? Pastor Dr. Hugh Hastings and Mother Dr. Wanda Hastings"
            className="w-full rounded-3xl border border-white/10 shadow-[0_0_60px_rgba(106,13,173,0.35)]"
            data-testid="church-banner-image"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8"
        >
          <CashAppLine testId="cashapp-top" />
        </motion.div>
      </div>
    </section>
  );
}
